import poland from "../images/HireMe/poland.png";
import Typewriter from "./hooks/type.jsx";
import React, { useState, useEffect } from "react";
import { Fade } from "react-awesome-reveal";
import email from "../images/HireMe/email.png";
import { useInView } from "react-intersection-observer";
import phone from "../images/HireMe/phone.png";
export const HireMe = ({ hireMeRef }) => {
    const pl = poland;
    const emailIcon = email;
    const phoneIcon = phone;
    // const [showSecondTypewriter, setShowSecondTypewriter] = useState(false);
    const [startTypewriter, setStartTypewriter] = useState(false);
    // const isTimeoutReady = useTimeout(() => {
    //     setShowSecondTypewriter(true);
    // }, 5500);
    // Use react-intersection-observer
    const [ref, inView] = useInView({
        triggerOnce: true,
    });

    useEffect(() => {
        if (inView) {
            // Component is in view, start animations
            setStartTypewriter(true);
        }
    }, [inView]);
    return (
        <div className="HireMe" ref={hireMeRef}>
            <div className="HireMe-Box2">
                <div className="HireMe-Box2-Text" ref={ref}>
                    <h2 className="HireMe-Box2-Text1">
                        Don't wait, let's get in touch !😃
                    </h2>
                    <div className="HireMe-Box2-Text2">
                        {startTypewriter && (
                            <Typewriter
                                text="If you are here it means You went through my portfolio
                        and we can start our
                        virtual engagement. I would love to use my skills to redefine innovation and passion in the digital world."
                                delay={45}
                            />
                        )}

                        <br />
                    </div>
                </div>
            </div>

            <div className="HireMe-Email">
                <div className="HireMe-Email-Img">
                    <img src={email} alt="email" />
                    <h4>Email:</h4>
                </div>
                <div className="HireMe-Email-Details">
                    <div>kaszkiel@gmail.com</div>
                    <a
                        href="mailto:kaszkiel@gmail.com?subject=Job%20Offer&body=Your%20Message"
                        style={{ fontWeight: "bold" }}
                    >
                        Compose Email
                    </a>
                </div>
            </div>
            <div className="HireMe-Contact">
                <div className="HireMe-Contact-Phone">
                    <img src={phone} alt="phone" />
                    <h4>Number:</h4>
                </div>
                <div className="HireMe-Contact-Box">
                    <img src={pl} alt="pl" />
                    <p>+48 505519381</p>
                </div>
            </div>
            <div className="HireMe-Profile">
                <h4>What defines me ?</h4>
                <div className="HireMe-Skills-Box">
                    <Fade
                        duration={2000}
                        style={{
                            borderLeft: "solid 10px black",
                            borderBottom: "solid 1px black",
                        }}
                    >
                        <div>
                            <i className="fa-solid fa-award"></i> Qualifications
                        </div>
                    </Fade>
                    <Fade duration={3000}>
                        <div>
                            <i className="fa-solid fa-bug"></i> Problem Solving
                            Mindset
                        </div>
                    </Fade>
                    <Fade duration={4000}>
                        <div>
                            <i className="fa-solid fa-people-group"></i>{" "}
                            Teamwork Player
                        </div>
                    </Fade>
                    <Fade duration={5000}>
                        <div>
                            <i className="fa-solid fa-hourglass-half"></i> Time
                            Management Expert
                        </div>
                    </Fade>
                    <Fade duration={6000}>
                        <div>
                            <i className="fa-solid fa-bolt"></i> Adaptable to
                            various conditions
                        </div>
                    </Fade>
                </div>
            </div>
        </div>
    );
};
